<template>
  <div class="sa-list-component">
    <div class="sa-list-component-body">
      <div class="b-table-sticky-header">
        <b-row>
          <b-col cols="6">
            <label class="sa-label-data">Tabella Riferimento Iva</label>
            <b-table sticky-header ref="table" stacked="xl" striped hover :items="ivaRighe" :fields="ivaFields" :current-page="1" :per-page="1000" sort-icon-left head-variant="light" class="sa-b-table">
              <template #cell(index)="row">
                {{ (currentPage - 1) * perPage + row.index + 1 }}
              </template>

              <template #cell(imponibileIva)="row">
                <strong> {{ row.item.imponibileIva.toLocaleString("it-IT", { style: "currency", currency: "EUR" }) }}</strong>
              </template>
            </b-table>
          </b-col>
          <b-col cols="6">
            <label class="sa-label-data">Tabella Riferimento Pagamenti</label>
            <b-table sticky-header ref="table" stacked="xl" striped hover :items="pagamentiRighe" :fields="pagamentiFields" :current-page="1" :per-page="1000" sort-icon-left head-variant="light" class="sa-b-table">
              <template #cell(index)="row">
                {{ (currentPage - 1) * perPage + row.index + 1 }}
              </template>
              <template #cell(descrizione)="row">
                <strong v-if="row.item.descrizione.includes('{numerodoc}')">{{ row.item.descrizione.replace("{numerodoc}", "") }}</strong>
                <strong v-else>{{ row.item.descrizione }}</strong>
              </template>
              <template #cell(stato)="row">
                <b-badge pill :variant="row.item.stato == 'NON PAGATO' ? 'danger' : row.item.stato == 'PAGATO' ? 'success' : 'warning'">
                  <strong>{{ row.item.stato }}</strong></b-badge
                >
              </template>
            </b-table>
          </b-col>
        </b-row>
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
export default {
  data() {
    return {
      pagamentiRighe: [],
      pagamentiFields: [
        {
          key: "importoScadenza",
          label: "Importo",
          formatter: function (value) {
            if (value) {
              value = value.toLocaleString("it-IT", { style: "currency", currency: "EUR" });
            } else if (value === 0) {
              value = value.toLocaleString("it-IT", { style: "currency", currency: "EUR" });
            }
            return value;
          },
        },
        {
          key: "descrizione",
          label: "Descrizione",
        },

        {
          key: "dataScadenza",
          label: "Scadenza",
          formatter: (value) => {
            return moment(new Date(value)).format("DD-MMM-YYYY");
          },
        },
        {
          key: "stato",
          label: "Stato",
        },
      ],
      ivaRighe: [],
      ivaFields: [
        {
          key: "descrizioneIva",
          label: "Iva",
        },
        {
          key: "aliquotaIva",
          label: "Alq.",
          formatter: function (value) {
            if (value) {
              value = value.toLocaleString("it-IT", { style: "percent" });
            } else if (value === 0) {
              value = value.toLocaleString("it-IT", { style: "percent" });
            }
            if (value > 0 && value <= 1) {
              value = value * 100;
              value = value.toLocaleString("it-IT", { style: "percent" });
            }

            return value;
          },
        },
        {
          key: "codiceIva",
          label: "Codice Iva",
        },
        {
          key: "impostaIva",
          label: "Imposta",
          formatter: function (value) {
            if (value) {
              value = value.toLocaleString("it-IT", { style: "currency", currency: "EUR" });
            } else if (value === 0) {
              value = value.toLocaleString("it-IT", { style: "currency", currency: "EUR" });
            }
            return value;
          },
        },
        {
          key: "imponibileIva",
          label: "Imponibile",
          formatter: function (value) {
            if (value) {
              value = value.toLocaleString("it-IT", { style: "currency", currency: "EUR" });
            } else if (value === 0) {
              value = value.toLocaleString("it-IT", { style: "currency", currency: "EUR" });
            }
            return value;
          },
        },
      ],
    };
  },
  methods: {
    init(jsonData) {
      this.ivaRighe = jsonData.righeDocumentoIva;
      this.pagamentiRighe = jsonData.righePagamenti;
    },
  },
};
</script>

<style scoped></style>
